import React from 'react';
import { useState } from 'react';
import { Image, Modal, Text, TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";
import * as Clipboard from 'expo-clipboard';

import AuthCodeInput from '../../components/Form/AuthCodeInput';
import HeaderDefault from "../../components/HeaderDefault";
import GradientButton from "../../components/GradientButton";

import { styles } from './styles';
import { useNavigation } from '@react-navigation/core';

const WithdrawGPXPassword = () => {
  const txId = '1230120302130210302103213120138128392183218931892183219392132';

  const [password, setPassword] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  const navigation = useNavigation();

  function onModalClose() {
    setModalVisible(false);
    navigation.navigate('Home');
  }

  function copyTxId() {
    Clipboard.setString(txId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <>
      <View style={{ flex: 1 }}>
        <HeaderDefault title="Confirmar saque" />

        <View style={styles.container}>
          <View>
            <AuthCodeInput
              cellCount={6}
              isPassword={true}
              value={password}
              onValueChange={(value) => setPassword(value)}
              label="Digite a sua senha "
            />
          </View>

          <GradientButton onPress={() => setModalVisible(true)}>CONFIRMAR SAQUE</GradientButton>
        </View>
      </View>
      <Modal
        animationType="slide"
        visible={modalVisible}
        presentationStyle="fullscreen"
        onRequestClose={onModalClose}
        style={styles.modal}
      >
        <View style={styles.modalContainer}>
          <TouchableOpacity onPress={onModalClose} style={styles.modalClose}>
            <MaterialIcons
              name="close"
              size={30}
              color="black"
            />
          </TouchableOpacity>
          <Image style={styles.modalSuccess} source={require('../../../assets/success.png')}></Image>
          <Text style={styles.modalText}>
            Seu saque foi enviado!{'\n'}
            Em breve você receberá o valor{'\n'}
            em sua conta.
          </Text>
          <Image resizeMode="contain" style={styles.modalImage} source={require('../../../assets/imgs/cardCoin.png')} />
        </View>
      </Modal>
    </>
  );
}

export default WithdrawGPXPassword;